<template>
    <div class="product-insights">
      <carousel :per-page="5" :navigationEnabled="true" :mouse-drag="false">
        <slide v-for="selfie in selfies" :key="selfie.id">
          <img :src="selfie.image" class="img-responsive" style="width: 95%;border: 2px solid #BDA340;"/>
        </slide>
      </carousel>
    </div>
</template>
<script>
import { time } from '@amcharts/amcharts4/core'
import { Carousel, Slide } from 'vue-carousel'

export default {
  name: 'ProductInsights',
  components: {
    Carousel,
    Slide
  },
  props: ['brandId'],
  data: function () {
    return {
      loading: true,
      localTime: '',
      selfies: [],
      image: '',
      userName: '',
      storeName: '',
      storeAddress: ''
    }
  },
  methods: {
    getBrandSocialSelfies () {
      this.$store.dispatch('getBrandSocialSelfies', this.brandId)
        .then(
          (response) => {
            console.log(response.body)
            this.selfies = response.body
            this.loading = false
            this.showLocaleTime()
            this.image = this.selfies[0]['image'] + '?width=300'
            this.storeAddress = this.selfies[0]['address']
            this.userName = this.selfies[0]['name']
            this.storeName = this.selfies[0]['store']
          }
        )
    }
  },

  mounted () {
    this.getBrandSocialSelfies()
  },
  watch: {

  }
}
</script>
